import React from 'react'
import Button from './Button'
import aboutMe from '../images/AboutMe.png'
import './About.css'

export default function About() {
  return (
    <div className='about-container flex-row'>
        <img className='about-img' src={aboutMe} alt='dp'/>
        <div className='about-text'>
            <div> A LITTLE MORE...</div>
            <div>About Me</div>
            <div className='about-paragraph'>
                <p>I am a GIS & Remote Sensing Specialist with a passion for transforming geospatial data into actionable insights. With expertise in satellite imagery analysis, spatial data engineering, and automation, I develop innovative solutions that bridge technology and real-world applications.  </p>
                <p>
                My experience spans Earth Observation, geospatial database management, and environmental monitoring, enabling me to design systems that enhance decision-making across various sectors. </p>
                <p>Driven by curiosity and innovation, I am committed to using geospatial intelligence to solve complex challenges and create meaningful impact. </p>
            </div>
            <div>
  <a 
    href="https://drive.google.com/file/d/1BNkEBL9yvBCb-0XyY0J9Hxgo2oaej9ak/view?usp=drive_link" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <Button text='DOWNLOAD MY CV'/>
  </a>
</div>

        </div>
    </div>
  )
}
